import { instantsInterceptor, } from '@/api/index';



function getLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}

function getExhaustCertiList(lang) {
    return instantsInterceptor.get('/mgmt/exhaustCertification/list?lang=' + lang);
}

function fetchExCertificationForm() {
    return instantsInterceptor.get('/mgmt/exhaustCertification/form');
}

function addExCertification(form) {
    return instantsInterceptor.post('/mgmt/exhaustCertification/form', form);
}

function getExCertiAndLabel(doctypeId) {
    return instantsInterceptor.get('/mgmt/exhaustCertification/updateForm/' + doctypeId);
}

function update(form) {
    return instantsInterceptor.post('/mgmt/exhaustCertification/update', form);
}

function updateExCertiOrder(form) {
    return instantsInterceptor.post('/mgmt/exhaustCertification/changeOrder', form);
}

function changeExCertiUse(form) {
    return instantsInterceptor.post('/mgmt/exhaustCertification/changeUse', form);
}

function deleteExCerti(form) {
    return instantsInterceptor.post('/mgmt/exhaustCertification/delete', form);
}

function getExhaustCerti() {
    return instantsInterceptor.get('/mgmt/exhaustCertification/all/list');
}

function checkExhaustDuplication(form) {
    return instantsInterceptor.post('/mgmt/exhaustCertification/check', form);
}

export {
    getLanguages,
    getExhaustCertiList,
    fetchExCertificationForm,
    addExCertification,
    getExCertiAndLabel,
    update,
    updateExCertiOrder,
    changeExCertiUse,
    deleteExCerti,
    getExhaustCerti,
    checkExhaustDuplication
};